var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'service-selector':true, ..._vm.classes}},_vm._l((_vm.servicesList),function(item,index){return _c('div',{key:index,class:{'item': true, 'selected': _vm.localSelected[item.id]},on:{"click":function($event){return _vm.select(item.id)}}},[_c('img',{attrs:{"src":item.image_icon}}),_c('label',[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }